export default [
    {id:1,name:"Admin"},
    {id:2,name:"Developer"},
    {id:3,name:"Internal Sales"},
    {id:4,name:"External Sales"},
    {id:5,name:"Investor"}
];

export function isPartnerUserRoleId(userRoleId) {
    return userRoleId == 4;
}


// WEBPACK FOOTER //
// ./app/constants/userRoles.js